import { AppStore } from '@/vuex'
import Vue, { VueConstructor } from 'vue'

/**
 * Add convenience global error handling code
 */
export const addErrorHandlers = (window: Window, ourVue: VueConstructor<Vue>, store: AppStore): void => {
  const oldWindowOnErrorHandler = window.onerror

  window.onerror = function (message, source, lineno, colno, error) {
    let result
    if (oldWindowOnErrorHandler) {
      result = oldWindowOnErrorHandler(message, source, lineno, colno, error)
    }

    store.dispatch.SHOW_ERROR({ handlerName: 'windowErrorHandler', error })
    return result
  }

  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    event.promise.catch(error => {
      store.dispatch.SHOW_ERROR({ handlerName: 'unhandledrejection', error })
      // NOTE: do not bubble the error forward. It'll cause a infinite error handling loop.
    })
  })

  const oldErrorHandler = Vue.config.errorHandler

  ourVue.config.errorHandler = (error: any, vm: Vue, info: string) => {
    let result
    if (oldErrorHandler) {
      result = oldErrorHandler(error, vm, info)
    }
    store.dispatch.SHOW_ERROR({ handlerName: 'vueErrorHandler', error })
    return result
  }
}
